// Local Storage Helpers with VC - VocalCentric prefix

export const getLS = (key: string): string | null => {
  return localStorage.getItem(`VC_${key}`);
};

export const setLS = (key: string, value: string): void => {
    return localStorage.setItem(`VC_${key}`, value);
}

export const removeLS = (key: string): void => {
    return localStorage.removeItem(`VC_${key}`);
}